import { render, staticRenderFns } from "./Poketime.vue?vue&type=template&id=6aff638a&scoped=true"
import script from "./Poketime.vue?vue&type=script&lang=js"
export * from "./Poketime.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aff638a",
  null
  
)

export default component.exports